// Auto-generated TypeScript enum from PHP enum

export type LogicalOperator = 'and' | 'nor' | 'or';

export const LogicalOperator = {
  And: 'and' as const,
  Nor: 'nor' as const,
  Or: 'or' as const,
} as const;

export const LogicalOperatorUtils = {
  values: Object.values(LogicalOperator),
  keys: Object.keys(LogicalOperator) as Array<keyof typeof LogicalOperator>,
  entries: Object.entries(LogicalOperator) as Array<[keyof typeof LogicalOperator, LogicalOperator]>,
  isValid: (value: any): value is LogicalOperator => Object.values(LogicalOperator).includes(value),
  fromKey: (key: keyof typeof LogicalOperator): LogicalOperator => LogicalOperator[key],
};

